import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";
import HR from "@origyn-sa/common-ui/src/components/atoms/HR/HR.styled";
import { NFTItem } from "@origyn-sa/common-ui/src/components/../api/types";
import { ListingType, PaymentMethodType } from "../../types";
import { displayPriceFromListing } from "../../utils";
import { client, ICPClient } from "../../agent";
import { Principal } from "@dfinity/agent";
import { toast } from "react-toastify";
import { LinearProgress } from "@material-ui/core";
import Label from "@origyn-sa/common-ui/src/components/atoms/Label";

export interface IBuyItemModal {
  open: boolean;
  onClose?: () => void;
  item: NFTItem;
  onConfirm: () => void;
  listing: ListingType;
  listingPaymentMethod: PaymentMethodType;
}

const BuyItemModal = ({
  open,
  onClose,
  item,
  onConfirm,
  listing,
  listingPaymentMethod,
}: IBuyItemModal): JSX.Element => {
  const [loader, setLoader] = useState<boolean>(false);
  const [recipient, setRecipient] = useState<string>("");
  const [order, setOrder] = useState<any>(undefined);
  const [orderIdx, setOrderIdx] = useState<number | undefined>(undefined);

  const refreshOrder = () => {
    setLoader(true);
    client.actor
      .get_orders(orderIdx, orderIdx)
      .then((order: any) => {
        setOrder(order?.[0]?.[1]?.[0]);
      })
      .catch((err: any) => {
        toast.error(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    let interval: any;
    refreshOrder();
    if (orderIdx !== undefined) {
      interval = setInterval(() => refreshOrder(), 5000);
    }
    return () => interval && clearInterval(interval);
  }, [orderIdx]);

  // useEffect(() => {
  //   if (order?.status) {
  //     console.debug({ order });
  //     const orderStatus = Object.keys(order?.status)[0];
  //     if (orderStatus !== "created") {
  //       toast.info(`Order finalized with status ${orderStatus}`);
  //     }
  //   }
  // }, [order]);

  const orderStatus = Object.keys(order?.status || {})[0];

  const createOrder = () => {
    console.debug({ item, listing });
    setLoader(true);
    // createOrder "(record { collectionPrincipal = principal \"$NFT_CANISTER\"; identifier=\"$MINTED_SN\" }, principal \"$ALICE_PRINCIPAL\" ,$UPDATED_AT)"
    try {
      client.actor
        .createOrder(
          listing.collectionItem,
          Principal.fromText(recipient),
          listing.updatedAt
        )
        .then((order: any) => {
          console.debug({ order });
          toast(`Order created: ${order.id}`);
          setOrderIdx(order.id);
        })
        .catch((err: Error) => {
          console.error(err);
          toast.error(`Error: ${err}`);
        })
        .finally(() => setLoader(false));
    } catch (err: any) {
      console.error(err);
      toast.error(err);
    }
  };

  console.debug("item", item, listing, listingPaymentMethod);
  console.debug({ orderIdx, order });
  return (
    <Dialog open={open} onClose={onClose}>
      {loader && <LinearProgress style={{ width: "100%", top: 0, left: 0 }} />}
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>Checkout</H3>
          </Grid>
        </Grid>
        <Form>
          <Grid container>
            <Grid item xs={12}>
              <Grid item container justify='space-between'>
                <Grid item>
                  <Text>SKU</Text>{" "}
                </Grid>
                <Text>{item.name}</Text>
              </Grid>
              <Grid item container justify='space-between'>
                <Grid item>
                  <Text>ID</Text>{" "}
                </Grid>
                <Grid item>
                  <Text>{item.id}</Text>
                </Grid>
              </Grid>
              <Grid item container justify='space-between'>
                <Grid item>
                  <Text>Price</Text>
                </Grid>
                <Grid item>
                  <Text>
                    {listing &&
                      displayPriceFromListing(listing, listingPaymentMethod)}
                  </Text>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <br />
          {orderIdx && order ? (
            <>
              <div>Order {orderIdx}:</div>
              <br />
              <Text>Status: {order && orderStatus}</Text>
              <Text>
                Expiry date:{" "}
                {order &&
                  new Date(Number(order?.expiresAt) / 1000000).toUTCString()}
              </Text>
              {/* <pre>{JSONBig.stringify(order, null, 2)}</pre> */}
              <br />
              {orderStatus === "created" ? (
                <>
                  <Label style={{ margin: "auto" }}>
                    Please send the payment
                  </Label>
                  <Text>
                    [1] Send{" "}
                    {listing &&
                      displayPriceFromListing(
                        listing,
                        listingPaymentMethod
                      )}{" "}
                    to{" "}
                    {
                      "d6a8bd48904f8e4375cdff7ac0cf01e08e9879f77125135e9851f8778cb644ec"
                    }
                  </Text>
                  <b>
                    $ dfx ledger --network ic transfer{" "}
                    {
                      "d6a8bd48904f8e4375cdff7ac0cf01e08e9879f77125135e9851f8778cb644ec"
                    }{" "}
                    --e8s {Number(listing.listingPrice)} --memo{" "}
                    {Number(orderIdx)}
                  </b>
                  <Text>
                    [2] Notify the canister with the block height BLOCKHEIGHT
                    returned from the transfer as the memo
                  </Text>
                  <b>
                    $ dfx canister --network ic --no-wallet call ledger
                    notify_dfx "record &#123; block_height = BLOCKHEIGHT;
                    to_canister = principal \"{ICPClient.getCanisterId()}\";
                    max_fee = record &#123; e8s = 10000 &#125;; from_subaccount
                    = null; to_subaccount = null; &#125;"
                  </b>
                </>
              ) : (
                <div style={{ overflowWrap: "break-word" }}>
                  Info: {order?.info}
                </div>
              )}
            </>
          ) : (
            <>
              <Grid item xs={12}>
                <InputField
                  disabled={loader}
                  required
                  label='Recipient Principal on NFT'
                  name='principal'
                  defaultValue={recipient}
                  onChange={(e: any) => {
                    setRecipient(e.target.value);
                  }}
                  placeholder='Principal'
                />
              </Grid>
              <HR />
              <Button
                onClick={() => {
                  createOrder();
                }}
                disabled={loader}
                spacing={2}
              >
                Create order
              </Button>
              <Text>
                Once you've created the order, you will have five minutes to pay
                for the item.
              </Text>
            </>
          )}
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default BuyItemModal;
